import React from 'react';
import { Select } from 'antd';

export type SortOption = {
    /** what the picker holds, since a sort is a field and a direction together */
    value: string;
    label: string;
    field: string;
    order: 'ASC' | 'DESC';
};

/**
 * The list's sort order.
 *
 * Sorting is not a filter value — it lives on the list context — but it belongs
 * wherever the filters are, so every list renders this in whichever slot its
 * layout gives it.
 *
 * Every option has to name a column the API can order by. A computed field will
 * either be ignored or error, depending on the endpoint, so keep them real.
 */
const SortSelect = ({
    options,
    currentSort,
    setSort,
    id = 'sort',
    dataCy = 'sort-selector',
}: {
    options: SortOption[];
    currentSort?: { field?: string; order?: string };
    setSort: (field: string, order: string) => void;
    id?: string;
    dataCy?: string;
}) => {
    const value = options.find((o) => o.field === currentSort?.field && o.order === currentSort?.order)?.value;

    return (
        <Select
            id={id}
            className="ft-control"
            data-cy={dataCy}
            value={value}
            placeholder={options[0]?.label}
            options={options.map((o) => ({ value: o.value, label: o.label }))}
            onChange={(next) => {
                const option = options.find((o) => o.value === next);
                if (option) setSort(option.field, option.order);
            }}
        />
    );
};

export default SortSelect;
